import React, { useEffect, useRef, useState } from 'react';
import {
  GuaranteesListItemResult,
  GuaranteesListResult,
  LeftColResult,
  LogoPriceContainer,
  PriceContainer,
  RightColResult,
  SelectedGuaranteesContainerResult,
  AiChatButtonEuropeassistance,
  AiChatButtonWrapper,
  EuropQuoteInformationResultContainer,
  EuropeassistanceCardResultStyles,
  LogoResultContainer,
  PriceResult,
  QuoteInformationResultItem,
  CompanyInfoElements,
  CompanyInformationContainer,
} from '../ResultPageComponents/v2/EuropeassistanceCardResult.styles';
import { BACKEND_BASE_URL } from '../../../../config';
import SparklesIcon from '../../../../assets/images/icons/SparklesIcon';
import { Chat } from '../../chats/MiniChat/MiniChat';
import preContractIcon from '../../../../assets/redesign_icons/pre-contract-icon.svg';
import axe from '../../../../services/axios-client/axiosClient';
import { downloadFile } from '../../../../services/axios-client/axeHelpers';
import getChatSubProduct from '../../../helpers/getChatSubProduct';
import { getTravelCoverageText } from '../../../helpers/travelCoverages';

function EuropeassistanceCardResult({ quote }) {
  const [openChat, setOpenChat] = useState(false);
  const chatRef = useRef();
  const [extraText, setExtraText] = useState(
    `Prezzo annuo: € ${parseFloat(quote.amount).toFixed(
      2,
    )} - Garanzie Aggiunte: `,
  );

  const downloadResourceDocs = async (producCode) => {
    const res = await axe.get(`/travel/informativa/${producCode}`, {
      responseType: 'blob',
    });

    downloadFile(res.data);
  };

  const getPrice = () => {
    let price = quote.amount;
    const quoteCovs = [];

    for (let i = 0; i < quote.quotation_coverages.length; i++) {
      const quoteCov = quote.quotation_coverages[i];

      quoteCovs.push(quoteCov.guarantees_slug);
    }

    if (quoteCovs.length > 0) {
      const groupedCoverages = quote.quotation_data_travel_europeassistance.coverages.filter((e) => quoteCovs.includes(e.coverage_id));

      for (let x = 0; x < groupedCoverages.length; x++) {
        const cov = groupedCoverages[x];
        price -= cov.coverage_amount_gros;
      }
    }

    return price;
  };

  useEffect(() => {
    if (quote) {
      setExtraText(getTravelCoverageText(quote));
    }
  }, [quote]);
  return (
    <EuropeassistanceCardResultStyles
      className={quote.is_aquista === 1 ? 'selected' : ''}
    >
      <LeftColResult>
        <Chat
          ref={chatRef}
          openChat={openChat}
          setOpenChat={setOpenChat}
          company_id={quote.company_id}
          product_id={quote.product_id}
          quote_type={quote.quote_type}
          company_name={quote.company.name}
          extraText={extraText}
          sub_product={getChatSubProduct(quote)}
        />
        <LogoPriceContainer>
          <LogoResultContainer>
            <img
              src={BACKEND_BASE_URL + quote.company.logo}
              alt={`${quote.company.name} Logo`}
            />
          </LogoResultContainer>
          <PriceContainer>
            <PriceResult>
              <h5>Prezzo annuo:</h5>
              <h2>
                €
                {parseFloat(getPrice()).toFixed(2)}
              </h2>
            </PriceResult>
          </PriceContainer>
        </LogoPriceContainer>
        <CompanyInformationContainer className="mt-2">
          <CompanyInfoElements
            onClick={() => downloadResourceDocs(quote.quotation_data_travel_europeassistance
              .product_code, 0)}
            title="Informativa Precontrattuale "
          >
            <img src={preContractIcon} alt="" />
            <p>{'Informativa Precontrattuale '}</p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
        <EuropQuoteInformationResultContainer>

          <QuoteInformationResultItem>
            <h6>Prodotto:</h6>
            <p>{quote.quotation_data_travel_europeassistance?.product_name}</p>
          </QuoteInformationResultItem>
          {quote.quotation_data_travel_europeassistance.coverages.map(
            (coverage, index) => (
              <React.Fragment key={index}>

                {quote.quotation_data_travel_europeassistance.product_code === 'EA0177' && coverage.enabled === 0 && coverage.group_id === null && (
                  <QuoteInformationResultItem>
                    <h6>
                      {coverage.title}
                      :
                    </h6>
                    <p>{coverage.limit_desc}</p>
                  </QuoteInformationResultItem>
                )}
                {quote.quotation_data_travel_europeassistance.product_code === 'EA0190' && coverage.enabled === 0 && coverage.group_id === '1' && (
                  <QuoteInformationResultItem>
                    <h6>
                      {coverage.title}
                      :
                    </h6>
                    <p>{coverage.limit_desc}</p>
                  </QuoteInformationResultItem>
                )}
                {/* {quote.quotation_coverages.map(
                  (cov, index) => coverage.coverage_id === cov.guarantees_slug && (
                    <QuoteInformationResultItem key={index}>
                      <h6>
                        {coverage.title}
                        :
                      </h6>
                      <p>{coverage.limit_desc}</p>
                    </QuoteInformationResultItem>
                  ),
                )} */}
              </React.Fragment>
            ),
          )}
        </EuropQuoteInformationResultContainer>
      </LeftColResult>
      <AiChatButtonWrapper>
        <AiChatButtonEuropeassistance onClick={() => setOpenChat(true)}>
          <SparklesIcon width={24} height={24} />
          <span>Chiedi all'AI</span>
        </AiChatButtonEuropeassistance>
      </AiChatButtonWrapper>
      <RightColResult>
        <SelectedGuaranteesContainerResult>
          <h5>
            <b>Garanzie</b>
            {' '}
            Aggiunte
          </h5>
          <GuaranteesListResult>
            {quote.quotation_data_travel_europeassistance.coverages.map(
              (coverage, index) => (
                <React.Fragment key={index}>
                  {quote.quotation_data_travel_europeassistance.product_code === 'EA0177' && coverage.enabled === 0 && coverage.group_id === null && (
                    <GuaranteesListItemResult>
                      <h6>
                        <span />
                        {' '}
                        {coverage.title}
                      </h6>
                      <p>
                        &euro;
                        {parseFloat(
                          coverage.coverage_amount_gros,
                        ).toLocaleString('en-US')}
                      </p>
                    </GuaranteesListItemResult>
                  )}
                  {quote.quotation_data_travel_europeassistance.product_code === 'EA0190' && coverage.enabled === 0 && coverage.group_id === '1' && (
                    <GuaranteesListItemResult>
                      <h6>
                        <span />
                        {' '}
                        {coverage.title}
                      </h6>
                      <p>
                        &euro;
                        {parseFloat(
                          coverage.coverage_amount_gros,
                        ).toLocaleString('en-US')}
                      </p>
                    </GuaranteesListItemResult>
                  )}
                  {/* {quote.quotation_coverages.map(
                    (cov, index) => coverage.coverage_id === cov.guarantees_slug && (
                      <GuaranteesListItemResult key={index}>
                        <h6>
                          <span />
                          {' '}
                          {cov.guarantees_description}
                        </h6>
                        <p>
                          &euro;
                          {parseFloat(cov.amount).toLocaleString('en-US')}
                        </p>
                      </GuaranteesListItemResult>
                    ),
                  )} */}
                </React.Fragment>
              ),
            )}
          </GuaranteesListResult>
        </SelectedGuaranteesContainerResult>
      </RightColResult>
    </EuropeassistanceCardResultStyles>
  );
}

export default EuropeassistanceCardResult;
